// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q5QSx","label":"styles_label__3ScmL"};